import { requestMethod } from "../../config";
import config from "../../env.config";
import { checkApiSuccess } from "../../utils";
import { fetch } from "./api.service";

/**
 * Get all automations
 */
export const getAutomations = async (data) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/trigger/getAutomations`,
    params: data,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const getAutomationInstance = async (data) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/trigger/getAutomationDetailedData`,
    params: data,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

/**
 * Get automation by ID
 */
export const getAutomationDetails = async (data) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/trigger/getAutomationDetails`,
    params: data,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data;
  }
};

/**
 * Create new automation
 */
export const addAutomation = async (payload) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/trigger/addAutomation`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, true);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

/**
 * Update automation trigger
 */
export const updateAutomationTrigger = async (data) => {
  let requestConfig = {
    method: requestMethod.PUT,
    url: `${config.BASE_URL.BASE_API_URL}/trigger/updateAutomationTrigger`,
    data: data,
  };
  let response = await fetch(requestConfig, true, true);
  if (checkApiSuccess(response)) {
    return response?.data?.data;
  } else if (response) getNotification(response.data.message, notifyIcon.ERROR_ICON);
};

/**
 * Delete automation
 */
export const deleteAutomation = async (payload) => {
  const requestConfig = {
    method: requestMethod.DELETE,
    url: `${config.BASE_URL.BASE_API_URL}/trigger/deleteAutomation`,
    data: payload,
  };
  const response = await fetch(requestConfig, true, true);
  if (checkApiSuccess(response)) {
    return response.data;
  }
};

/**
 * Delete automation trigger
 */
export const deleteAutomationTrigger = async (payload) => {
  const requestConfig = {
    method: requestMethod.DELETE,
    url: `${config.BASE_URL.BASE_API_URL}/trigger/deleteAutomationTrigger`,
    data: payload,
  };
  const response = await fetch(requestConfig, true, true);
  if (checkApiSuccess(response)) {
    return response.data;
  }
};

/**
 * Update automation
 */
export const updateAutomation = async (data) => {
  let requestConfig = {
    method: requestMethod.PUT,
    url: `${config.BASE_URL.BASE_API_URL}/trigger/updateAutomation`,
    data: data,
  };
  let response = await fetch(requestConfig, true, true);
  if (checkApiSuccess(response)) {
    return response?.data?.data;
  } else if (response) getNotification(response.data.message, notifyIcon.ERROR_ICON);
};

export const addUpdateAutomationGroup = async (payload) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/trigger/addUpdateAutomationGroup`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const addAutomationTrigger = async (payload) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/trigger/addAutomationTrigger`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, true);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

/**
 * Add trigger task
 */
export const addTriggerTask = async (payload) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/trigger/addTriggerTask`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, true);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const getTriggeredTasks = async (parentTaskId) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/trigger/getTriggerChildTasks`,
    params: { taskId: parentTaskId },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const getTriggerTaskSmartChips = async (data) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/trigger/getTriggerTaskSmartChips`,
    params: data,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

export const deleteInstance = async (data) => {
  const requestConfig = {
    method: requestMethod.DELETE,
    url: `${config.BASE_URL.BASE_API_URL}/trigger/deleteTriggerInstance`,
    data: data,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.success;
  }
};

export const getAutomationGroups = async (data) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/trigger/getAutomationGroups`,
    params: data,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data;
  }
};

/**
 * Check automation name availability
 */
export const checkAutomationNameAvailability = async (payload) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/trigger/checkAutomationNameAvailability`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};

/**
 * Check automation trigger name availability
 */
export const checkAutomationTriggerNameAvailability = async (payload) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/trigger/checkAutomationTriggerNameAvailability`,
    data: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};